import React from 'react';
import { useHistory } from 'react-router-dom';
import {
  ButtonBack,
  ContainerProcedure,
  SubContainer
} from '../../../certificates-constancies/type1/info/components';
import { BtnRequest } from '../../IssuanceUniversityCard/info/components/styled';
import Spinner from '../../../../../../components/Spinner';
import { ProcedureInfoData } from './components/ProcedureInfoComponent';
import MyModal from '@/presentation/modules/procedures/components/Modals/MyModal';
import RequestExist from '@/presentation/modules/procedures/components/Modals/RequestExists';
import Modal from '../../../../components/Modal/Modal';
import NotAvailable from '@/presentation/modules/procedures/components/Modals/NotAvailable';
import ProcedureHeader from '@/presentation/modules/procedures/components/ContainerProcedure/Header';

interface ReincorporationInfoViewProps {
  procedureSelectedInfo: any;
  handlerRequest: () => void;
  goBack: () => void;
  errorModal: {
    showErrorModal: boolean;
    setShowErrorModal: (error: boolean) => void;
  };
  existsModal: {
    showExistsModal: boolean;
    setShowExistsModal: (error: boolean) => void;
  };
  notAvailableModal: {
    showNotAvailableModal: boolean;
    setShowNotAvailableModal: (error: boolean) => void;
  };
  notRequiredModal: {
    showNotRequiredModal: boolean;
    setShowNotRequiredModal: (error: boolean) => void;
  };
  goToCurrentRequest: () => void;
}

// comentario

const ReincorporationInfoView = ({
  procedureSelectedInfo,
  handlerRequest,
  goBack,
  errorModal,
  existsModal,
  notAvailableModal,
  notRequiredModal,
  goToCurrentRequest
}: ReincorporationInfoViewProps) => {
  const { showErrorModal, setShowErrorModal } = errorModal;
  const { showExistsModal, setShowExistsModal } = existsModal;
  const { showNotAvailableModal, setShowNotAvailableModal } = notAvailableModal;

  const history = useHistory();

  const routeTo = () => {
    history.push('/tramites');
  };

  return (
    <div data-testid="cmp-reincorporationinfoview">
      <ContainerProcedure>
        <SubContainer>
          <ButtonBack onClick={goBack} />
          <ProcedureHeader name="Reincorporación" />
        </SubContainer>
        <SubContainer>
          {!procedureSelectedInfo && <Spinner />}
          {procedureSelectedInfo && (
            <>
              <ProcedureHeader
                amount={procedureSelectedInfo?.amount}
                duration={procedureSelectedInfo?.duration}
                date={procedureSelectedInfo?.endDate}
                twoLineFormat
                paddingData={12}
              />
              <ProcedureInfoData />
              <BtnRequest
                data-testid="cmp-btnrequest-change"
                onClick={handlerRequest}
              >
                <p>Empezar solicitud</p>
              </BtnRequest>
            </>
          )}
        </SubContainer>
      </ContainerProcedure>
      <Modal
        show={showNotAvailableModal}
        handleClose={() => setShowNotAvailableModal(false)}
      >
        <NotAvailable handleClick={routeTo} />
      </Modal>
      <Modal
        show={showExistsModal}
        handleClose={() => setShowExistsModal(false)}
      >
        <RequestExist handleClick={goToCurrentRequest} />
      </Modal>
      <MyModal
        show={showErrorModal}
        data={{
          title: procedureSelectedInfo?.error?.title,
          description: procedureSelectedInfo?.error?.description
        }}
        handlerClick={routeTo}
        handlerClose={() => {
          setShowErrorModal(false);
        }}
      />
      <MyModal
        show={notRequiredModal.showNotRequiredModal}
        data={{
          title: 'No necesitas realizar este trámite',
          description:
            'Podrás matricularte sin realizar ninguna solicitud el próximo ciclo.'
        }}
        handlerClick={() => notRequiredModal.setShowNotRequiredModal(false)}
        handlerClose={() => notRequiredModal.setShowNotRequiredModal(false)}
      />
    </div>
  );
};

export default ReincorporationInfoView;
